import Vue from 'vue'
import Router from 'vue-router'
import Frame from '../views/layout/Frame'
import $Lang from '@/utils/language'

Vue.use(Router)

/**
 * ------------------------------------------------------------------
 * 权限说明
 *   - 连锁店铺权限  chainAdmin       拥有连锁店特有的功能
 *   - 默认店铺权限  defaultAdmin     拥有添加编辑商品分类、品牌、单位、会员、会员等级等功能
 *   - 普通店铺权限  commonAdmin      不具有连锁店铺、默认店铺特有权限其余权限
 *   - 账户角色权限  sellerRole       根据角色配置分配权限
 * ------------------------------------------------------------------
 */

export const defaultRouterMap = [
    {
        path: '/test',
        name: 'test',
        component: view('test/Index')
    },
    {
        path: '',
        component: Frame,
        redirect: 'dashboard',
        meta: { title: '概览', icon: 'ti-desktop', iconColor: 'c-blue-500' },
        hidden: true,
        children: [
            {
                  path: 'dashboard',
                  component: view('dashboard/Index'),
                  name: 'dashboard',
                  meta: { title: '控制台' }
            }
        ]
    },
    {
        path: '/signin',
        name: 'signin',
        component: view('passport/Signin')
    },
    {
        path: '/signup',
        name: 'signup',
        component: view('passport/Signup')
    },
    {
        path: '/forget',
        name: 'forget',
        component: view('passport/Forget')
    },
    {
        path: '/404',
        name: '404',
        component: view('errorPage/404')
    },
    {
        path: '/agreement',
        name: 'agreement',
        component: view('passport/Agreement')
    },
    {
        path: '/system',
        component: Frame,
        hidden: true,
        children: [
            {
                  path: 'shopupgrade',
                  component: view('shop/Upgrade'),
                  name: 'shopupgrade'
            }
        ]
    }
]

export const permissionRouterMap = [
    {
        path: '/reports',
        component: Frame,
        meta: { title: $Lang('统计'), icon: 'ti-bar-chart', iconColor: 'c-indigo-500' },
        children: [
            {
                path: 'business',
                name: 'reportsBusiness',
                component: view('reports/Business'),
                meta: { title: $Lang('营业概览'), workName: 'reports.group.showStatsDay' }
            },
            {
                path: 'trend',
                name: 'reportsTrend',
                component: view('reports/Trend'),
                meta: { title: $Lang('营业趋势'), workName: 'reports.group.showStatsTrend' }
            },
            {
                path: 'exchange',
                name: 'reportsExchange',
                component: view('reports/Exchange'),
                meta: { title: $Lang('员工交接班记录'), workName: 'reports.group.showStatsEmployee' }
            },
            {
                path: 'cashinout',
                name: 'reportsCashInOut',
                component: view('reports/Cashinout'),
                meta: { title: $Lang('现金收支记录'), workName: 'reports.group.showCashinout' }
            },
            {
                path: 'goodsstats',
                name: 'reportsGoodsStats',
                component: view('reports/Goodsstats'),
                meta: { title: $Lang('商品销售统计'), workName: 'reports.group.showGoodsStatsDay' }
            },
            {
                path: 'slowmoving',
                name: 'reportsSlowMoving',
                component: view('reports/SlowMoving'),
                meta: { title: $Lang('商品滞销统计'), workName: 'reports.group.showSlowMoving' }
            },
            {
                path: 'goodsdiscart',
                name: 'reportsGoodsDiscart',
                component: view('reports/GoodsDiscart'),
                meta: { title: $Lang('商品报损统计'), workName: 'reports.group.showDiscard' },
                children: [
                    {   
                        path: 'detail/:id?',
                        name: 'PopupDiscartDetail',
                        meta: { title: $Lang('报损详情'), component: 'reports/DiscartDetail' },
                        hidden: true
                    }   
                ]
            },
            {
                path: 'reportProductInformation',
                name: 'reportProductInformation',
                component: view('reports/ProductInformation'),
                meta: { title: $Lang('扩展商品销售统计'), workName: 'reports.group.showreportProductInformation' },
            },
        ]
    },
    {
        path: '/shop',
        component: Frame,
        meta: { title: $Lang('店铺'), icon: 'ti-home', iconColor: 'c-indigo-500' },
        children: [
            {
                path: 'list',
                name: 'shopList',
                component: view('shop/List'),
                meta: { title: $Lang('店铺列表'), roles: ['chainWithDefaultAdmin'], workName: 'shop.group.showShopList' },
                children: [
                    {
                        path: 'editor/:id?',
                        name: 'PopupShopListEditor',
                        meta: { title: $Lang('店铺添加/修改'), roles: ['chainAdmin'], component: 'shop/Editor', workName: 'shop.group.addShop' },
                        hidden: true
                    }
                ]
            },
            {
                path: 'account',
                name: 'shopAccount',
                component: view('shop/Account'),
                meta: { title: $Lang('账号列表'), workName: 'shop.group.showSellerList' },
                children: [
                    {
                        path: 'editor/:id?',
                        name: 'PopupShopAccountEditor',
                        meta: { title: $Lang('账号添加/修改'), component: 'shop/AccountEditor', workName: ['shop.group.addSeller', 'shop.group.modifySeller'] },
                        hidden: true
                    }
                ]
            },
            {
                path: 'roles',
                name: 'shopRoles',
                component: view('shop/Roles'),
                meta: { title: $Lang('账号角色'), workName: 'shop.group.showRoles' },
                children: [
                    {
                        path: 'editor/:id?',
                        name: 'PopupRolesEditor',
                        meta: { title: $Lang('角色添加/修改'), component: 'shop/RolesEditor', workName: ['shop.group.addRoles', 'shop.group.modifyRoles'] },
                        hidden: true
                    }
                ]
            }
        ]
    },
    {
        path: '/goods',
        component: Frame,
        meta: { title: $Lang('商品'), icon: 'ti-support', iconColor: 'c-deep-orange-500' },
        children: [
            {
                path: 'list',
                name: 'goodsList',
                component: view('goods/List'),
                meta: { title: $Lang('商品列表'), workName: 'goods.group.showGoods' }
            },
            {
                path: 'editor/:id?',
                name: 'PopupGoodsEditor',
                meta: { title: $Lang('商品添加'), component: 'goods/Editor', workName: ['goods.group.addGoods', 'goods.group.modifyGoods'] },
                hidden: true
            },
            {
                path: 'import',
                name: 'PopupGoodsImport',
                meta: { title: $Lang('商品导入'), component: 'goods/Import', workName: 'goods.group.addGoods' },
                hidden: true
            },
            {
                path: 'category',
                name: 'goodsCategory',
                component: view('goods/Category'),
                meta: { title: $Lang('商品分类'), workName: 'goods.group.showCategory' },
                children: [
                    {
                        path: 'editor/:id?',
                        name: 'PopupGoodsCategoryEditor',
                        meta: { title: $Lang('商品分类编辑'), roles: ['defaultAdmin'], component: 'goods/CategoryEditor', workName: ['goods.group.addCategory', 'goods.group.modifyCategory'] },
                        hidden: true
                    }
                ]
            },
            {
                path: 'brand',
                name: 'goodsBrand',
                component: view('goods/Brand'),
                meta: { title: $Lang('商品品牌'), workName: 'goods.group.showBrand' },
                children: [
                    {
                        path: 'editor/:id?',
                        name: 'PopupGoodsBrandEditor',
                        meta: { title: $Lang('商品品牌编辑'), roles: ['defaultAdmin'], component: 'goods/BrandEditor', workName: ['goods.group.addBrand', 'goods.group.modifyBrand'] },
                        hidden: true
                    }
                ]
            },
            {
                path: 'unit',
                name: 'goodsUnit',
                component: view('goods/Unit'),
                meta: { title: $Lang('商品单位'), workName: 'goods.group.showUnit' },
                children: [
                    {
                        path: 'editor/:id?',
                        name: 'PopupGoodsUnitEditor',
                        meta: { title: $Lang('商品标签编辑'), roles: ['defaultAdmin'], component: 'goods/UnitEditor', workName: ['goods.group.addUnit', 'goods.group.modifyUnit'] },
                        hidden: true
                    }
                ]
            },
            {
                path: 'remark',
                name: 'goodsRemark',
                component: view('goods/Remark'),
                meta: { title: $Lang('商品备注'), workName: 'goods.group.showRemark' },
                children: [
                    {
                        path: 'editor/:id?',
                        name: 'PopupGoodsRemarkEditor',
                        meta: { title: $Lang('商品备注编辑'), roles: ['defaultAdmin'], component: 'goods/RemarkEditor', workName: ['goods.group.addRemark', 'goods.group.modifyRemark'] },
                        hidden: true
                    }
                ]
            },
            {
                path: 'split',
                name: 'goodsSplit',
                component: view('goods/Split'),
                meta: { title: $Lang('商品拆分'), workName: 'goods.group.showSplit' }
            },
            {
                path: 'supplier',
                name: 'goodsSupplier',
                component: view('goods/Supplier'),
                meta: { title: $Lang('供应商'), workName: 'goods.group.showSupplier' },
                children: [
                    {
                        path: 'editor/:id?',
                        name: 'PopupGoodsSupplierEditor',
                        meta: { 
                            title: $Lang('供应商编辑'), 
                            roles: ['defaultAdmin'], 
                            component: 'goods/SupplierEditor', 
                            workName: ['goods.group.addSupplier', 'goods.group.modifySupplier'] 
                        },
                        hidden: true
                    }
                ]
            },
            {
                path: 'ProductInformation',
                name: 'goodsProductInformation',
                component: view('goods/ProductInformation'),
                meta: { title: $Lang('扩展信息'), workName: 'goods.group.showProductInformation' },
                children: [
                    {
                        path: 'editor/:id?',
                        name: 'PopupGoodsProductInformationEditor',
                        meta: { 
                            title: $Lang('供应商编辑'), 
                            roles: ['defaultAdmin'], 
                            component: 'goods/ProductInformationEditor', 
                            workName: ['goods.group.addProductInformation', 'goods.group.modifyProductInformation'] 
                        },
                        hidden: true
                    }
                ]
            },
        ]
    },
    {
        path: '/stock',
        component: Frame,
        meta: { title: $Lang('库存'), icon: 'ti-harddrives', iconColor: 'c-deep-purple-500' },
        children: [
            {
                path: 'list',
                name: 'stockList',
                component: view('stock/List'),
                meta: { title: $Lang('库存查询'), workName: 'stock.group.showWarning' },
                hidden: true
            },
            {
                path: 'warning',
                name: 'stockWarning',
                component: view('stock/Warning'),
                meta: { title: $Lang('库存预警'), workName: 'stock.group.showWarning' }
            },
            {
                path: 'changeHistory',
                name: 'stockChangeHistory',
                component: view('stock/ChangeHistory'),
                meta: { title: $Lang('变更明细'), workName: 'stock.group.showChangeHistory' }
            },
            {
                path: 'flowList',
                name: 'stockFlowList',
                component: view('stock/FlowList'),
                meta: { title: $Lang('货流管理'), workName: 'stock.group.showStock' }
            },
            {
                path: 'flowListDetail/:id?/:stock_type?',
                name: 'PopupStockFlowListDetail',
                component: view('stock/FlowListDetail'),
                meta: { title: $Lang('货流详情查看'), component: 'stock/FlowListDetail', workName: 'stock.group.showStock' },
                hidden: true
            },
            {
                path: 'flowListConfirm/:id?/:stock_status?',
                name: 'PopupStockFlowListConfirm',
                component: view('stock/FlowListConfirm'),
                meta: { title: $Lang('货流确认查看'), component: 'stock/FlowListConfirm', workName: 'stock.group.showStock' },
                hidden: true
            },
            {
                path: 'stockIn/:shop_id?/:warehouse_id?',
                name: 'stockIn',
                component: view('stock/StockIn'),
                meta: { title: $Lang('入库'), workName: 'stock.group.stockIn' },
                hidden: true
            },
            {
                path: 'stockInFirst',
                name: 'PopupStockInFirst',
                component: view('stock/StockInFirst'),
                meta: { title: $Lang('入库选择'), component: 'stock/StockInFirst', workName: 'stock.group.stockIn' },
                hidden: true
            },
            {
                path: 'stockOut/:shop_id?/:stock_type?/:price_type?/:from_shop_id?',
                name: 'stockOut',
                component: view('stock/StockOut'),
                meta: { title: $Lang('出库'), workName: 'stock.group.stockOut' },
                hidden: true
            },
            {
                path: 'stockOutFirst',
                name: 'PopupStockOutFirst',
                component: view('stock/StockOutFirst'),
                meta: { title: $Lang('出库选择'), component: 'stock/StockOutFirst', workName: 'stock.group.stockOut' },
                hidden: true
            },
            // {
            //     path: 'exportList',
            //     name: 'stockExportList',
            //     component: view('stock/ExportList'),
            //     meta: { title: $Lang('生成货单') },
            //     hidden: true
            // },
            // {
            //     path: 'export',
            //     name: 'stockExport',
            //     component: view('stock/Export'),
            //     meta: { title: $Lang('导出') },
            //     hidden: true
            // },
            {
                path: 'import',
                name: 'PopupstockImport',
                component: view('stock/Import'),
                meta: { title: $Lang('导入'), component: 'stock/Import', workName: 'stock.group.stockOut' },
                hidden: true
            }
        ]
    },
    {
        path: '/member',
        component: Frame,
        meta: { title: $Lang('会员'), icon: 'ti-id-badge', iconColor: 'c-pink-500' },
        children: [
            {
                path: 'list',
                name: 'memberList',
                component: view('member/List'),
                meta: { title: $Lang('会员列表'), workName: 'member.group.showMember' },
                children: [
                    {
                        path: 'editor/:id?',
                        name: 'PopupMemberEditor',
                        meta: { title: $Lang('会员编辑'), component: 'member/Editor', workName: ['member.group.addMember', 'member.group.modifyMember'] },
                        hidden: true
                    }
                ]
            },
            {
                path: 'import',
                name: 'PopupMemberImport',
                meta: { title: $Lang('会员导入'), component: 'member/Import', workName: ['member.group.addMember'] },
                hidden: true
            },
            {
                path: 'level',
                name: 'memberLevel',
                component: view('member/Level'),
                meta: { title: $Lang('会员等级'), workName: 'member.group.showLevel' },
                children: [
                    {
                        path: 'editor/:id?',
                        name: 'PopupMemberLevelEditor',
                        meta: { title: $Lang('会员等级编辑'), roles: ['defaultAdmin'], component: 'member/LevelEditor', workName: ['member.group.addLevel', 'member.group.modifyLevel'] },
                        hidden: true
                    }
                ]
            },
            {
                path: 'rechargelog',
                name: 'memberRechargeLog',
                component: view('member/RechargeLog'),
                meta: { title: $Lang('会员充值记录'), workName: 'member.group.showRechargeList' }
            },
            {
                path: 'memberbuygoods',
                name: 'memberbuygoods',
                component: view('member/Memberbuygoods'),
                meta: { title: $Lang('会员购买商品统计'), workName: 'member.group.showGoodsCount' }
            }
        ]
    },
    {
        path: '/sales',
        component: Frame,
        meta: { title: $Lang('营销'), icon: 'ti-gift', iconColor: 'c-orange-500' },
        children: [
            // {
            //     path: 'member',
            //     name: 'salesMember',
            //     component: view('sales/Member'),
            //     meta: { title: $Lang('会员精准营销') }
            // },
            {
                path: 'promotion',
                name: 'salesPromotion',
                component: view('sales/Promotion'),
                meta: { title: $Lang('促销活动'), workName: 'promotion.group.showList' },
                children: [
                    {
                        path: 'editor/:id?',
                        name: 'PopupPromotionEditor',
                        meta: { title: $Lang('促销编辑'), component: 'sales/PromotionEditor', workName: ['promotion.group.addList', 'promotion.group.modifyList'] },
                        hidden: true
                    }
                ]
            }
        ]
    },
    {
        path: '/cashier',
        component: Frame,
        meta: { title: $Lang('员工'), icon: 'ti-user', iconColor: 'c-teal-500' },
        children: [
            {
                path: 'list',
                name: 'cashierList',
                component: view('cashier/List'),
                meta: { title: $Lang('员工列表'), workName: 'cashier.group.showEmployee' }
            },
            {
                path: 'role',
                name: 'cashierRole',
                component: view('cashier/Role'),
                meta: { title: $Lang('角色列表'), workName: 'cashier.group.showRole' }
            },
            {
                path: 'add',
                name: 'cashieradd',
                component: view('cashier/Add'),
                meta: { title: $Lang('员工添加'), workName: 'cashier.group.addEmployee' },
                hidden: true
            },
            {
                path: 'editor/:id?',
                name: 'cashierupdate',
                component: view('cashier/Add'),
                meta: { title: $Lang('员工修改'), workName: 'cashier.group.modifyEmployee' },
                hidden: true
            },
            {
                path: 'roleeditor/:id?',
                name: 'PopupCashierUpdateRole',
                meta: { title: $Lang('角色添加/修改'), component: 'cashier/RoleEditor', workName: ['cashier.group.addRole', 'cashier.group.modifyRole'] },
                hidden: true
            }
        ]
    },
    {
        path: '/store',
        component: Frame,
        meta: { title: $Lang('仓库'), icon: 'ti-package', iconColor: 'c-purple-500' },
        children: [
            {
                path: 'list',
                name: 'storelist',
                component: view('store/List'),
                meta: { title: $Lang('仓库列表'), workName: 'store.group.showWarehouseList' }
            },
            {
                path: 'editor/:id?',
                name: 'PopupStoreEdit',
                meta: { title: $Lang('仓库添加/修改'), component: 'store/Editor', workName: ['store.group.addWarehouse', 'store.group.modifyWarehouse'] },
                hidden: true
            }
        ]
    },
    {
        path: '/order',
        component: Frame,
        meta: { title: $Lang('订单'), icon: 'ti-view-list', iconColor: 'c-purple-500' },
        children: [
            {
                path: 'list',
                name: 'orderlist',
                component: view('order/List'),
                meta: { title: $Lang('订单列表'), workName: 'order.group.showOrder' },
                children: [
                    {
                        path: 'detail/:id?',
                        name: 'PopupOrderDetail',
                        meta: { title: $Lang('订单详情'), component: 'order/OrderDetail', workName: 'order.group.showOrder' },
                        hidden: true
                    }
                ]
            },
            {
                path: 'refundList',
                name: 'refundList',
                component: view('order/refundList'),
                meta: { title: $Lang('退单列表'), workName: 'order.group.showOrder' },
                children: [
                    {
                        path: 'editor/:id?',
                        name: 'PopupreFundEdit',
                        meta: { title: $Lang('退款审核'), component: 'order/Editor', workName: 'order.group.showOrder' },
                        hidden: true
                    }
                ]
            },
        ]
    },
    {
        path: '/food',
        component: Frame,
        meta: { title: $Lang('餐饮'), icon: 'fa fa-cutlery', iconColor: 'c-brown-500' },
        children: [
            {
                path: 'deskList',
                name: 'foodDesk',
                component: view('food/Desk'),
                meta: { title: $Lang('桌台管理'), workName: 'food.group.showFoodDesk' },
                children: [
                    {
                        path: 'editor/:id?',
                        name: 'PopupDeskEditor',
                        meta: { title: $Lang('编辑'), component: 'food/DeskEditor', workName: ['food.group.addFoodDesk', 'food.group.modifyFoodDesk'] },
                        hidden: true
                    }
                ]
            },
            {
                path: 'kitchenprintList',
                name: 'foodKitchenprint',
                component: view('food/Kitchenprint'),
                meta: { title: $Lang('后厨设备'), workName: 'food.group.showDevice' },
                children: [
                    {
                        path: 'editor/:id?',
                        name: 'PopupKitchenprintEditor',
                        meta: { title: $Lang('编辑'), component: 'food/KitchenprintEditor', workName: ['food.group.addDevice', 'food.group.modifyDevice'] },
                        hidden: true
                    }
                ]
            },
            {
                path: 'foodOrdergoods',
                name: 'foodOrdergoods',
                component: view('food/Ordergoods'),
                meta: { title: $Lang('后厨菜品记录'), workName: 'food.group.showFoodOrdergoods' },
                children: [
                    {
                        path: 'editor/:id?',
                        name: 'PopupOrdergoodsEditor',
                        meta: { title: $Lang('编辑'), component: 'food/OrdergoodsEditor' },
                        hidden: true
                    }
                ]
            },
            {
                path: 'foodQueue',
                name: 'foodQueue',
                component: view('food/Queue'),
                meta: { title: $Lang('排队'), workName: 'food.group.foodQueue' },
                children: [
                    {
                        path: 'editor/:id?',
                        name: 'PopupFoodQueue',
                        meta: { title: $Lang('编辑'), component: 'food/PopupFoodQueue' },
                        hidden: true
                    }
                ]
            }
        ]
    },
    {
        path: '/recommend',
        component: Frame,
        meta: { title: $Lang('邀请有礼'), icon: 'fa fa-share-alt', iconColor: 'c-red-500' },
        children: [
            {
                path: 'index',
                name: 'recommendIndex',
                component: view('recommend/Index'),
                meta: { title: $Lang('邀请商户得红包') }
            }
        ]
    },
    {
        path: '/setting',
        component: Frame,
        meta: { title: $Lang('设置'), icon: 'ti-settings', iconColor: 'c-cyan-500' },
        hidden: false,
        children: [
            {
                path: 'shop',
                name: 'settingShop',
                component: view('setting/Shop'),
                meta: { title: $Lang('店铺资料'), workName: ['shop.group.getShopInfo', 'shop.group.updateShopInfo'] }
            }
        ]
    },
    /*
    {
        path: '/onlineshop',
        component: Frame,
        meta: { title: $Lang('网店'), icon: 'ti-world', iconColor: 'c-brown-500', roles: ['superadmin', 'admin'] },
        children: [
            {
                path: 'list',
                name: 'onlineshopList',
                component: view('onlineshop/List'),
                meta: { title: $Lang('网店') }
            }
        ]
    },
    {
        path: '/setting',
        component: Frame,
        meta: { title: $Lang('设置'), icon: 'ti-settings', iconColor: 'c-cyan-500', roles: ['superadmin', 'admin'] },
        children: [
            {
                path: 'list',
                name: 'settingAccount',
                component: view('setting/List'),
                meta: { title: $Lang('账户管理') }
            },
            {
                path: 'list',
                name: 'settingList',
                component: view('setting/List'),
                meta: { title: $Lang('系统设置') }
            },
            {
                path: 'list',
                name: 'settingPay',
                component: view('setting/List'),
                meta: { title: $Lang('支付方式') }
            },
            {
                path: 'list',
                name: 'settingLog',
                component: view('setting/List'),
                meta: { title: $Lang('操作日志') }
            }
        ]
    },
    */
    { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
    // h5 history模式
    // mode: 'hash',
    mode: typeof history.pushState !== 'undefined' ? 'history' : 'hash',
    routes: defaultRouterMap
})

function view (name) {
    return resolve => require(['@/views/' + name], resolve)
}



// WEBPACK FOOTER //
// ./src/router/index.js